import React, { useEffect } from 'react'
import { HiOutlineDocumentDuplicate } from 'react-icons/hi2'
import { MdOutlineLibraryBooks } from 'react-icons/md'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import PageTitle from '../../../../components/partials/PageTitle'
import { resetCustomerOverviewData } from '../../../../redux/slice/report/reportSlice'


const customerReports = [
    {name: 'Individual Savings Report',icon: <HiOutlineDocumentDuplicate size={26}/>, link: '/admin/reports/savings-policy-report/individual-savings-report', permission: 'customer policy information report'},
    {name: 'Savings Claims Report',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/savings-policy-report/savings-claim-report', permission: 'customer policy information report'},
    {name: 'Savings Account Balance Report',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/savings-policy-report/savings-account-balance', permission: 'customer policy information report'},
    {name: 'Savings Policy Information Report',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/savings-policy-report/savings-policy-information', permission: 'customer policy information report'},
    {name: 'Savings Contribution Payment',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/savings-policy-report/savings-contribution-payment', permission: 'customer policy information report'},
    // {name: 'Savings Performance Report',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/savings-policy-report/savings-performance-report', permission: 'customer policy information report'},
    // {name: 'Interest Report',icon: <MdOutlineLibraryBooks size={26} />, link: '/admin/reports/savings-policy-report/interest-report', permission: 'customer policy information report'},
]
const SavingsPolicyReport = () => {

    const { user_permissions } = useSelector((state) => state?.auth?.user);

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const breadcrumb = {
        from: {
          title: "Reports",
          link: "/admin/reports",
        },
        current: {
          title: "Savings Policy Report",
          link: null,
        },
      };

    useEffect(() => {
      dispatch(resetCustomerOverviewData())
    }, [dispatch])

    const filteredReports = customerReports.filter((item) => {
      return user_permissions?.some((permission) => permission.name === item.permission);
    });
    
    useEffect(() => {
      if (!user_permissions?.some(permission => permission.name === 'customer report module')) {
        navigate('/admin/dashboard')
      }
    }, [navigate, user_permissions])
  return (
    <>
        {/* page title */}
        <PageTitle title='Savings Policy Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className='row gap-4 p-1 mt-2' style={{ margin: "auto 1px" }}>
            {filteredReports.map((item, i) => (
                <Link to={item?.link} className='col-3 card p-3 hover-primary' key={i}>
                    <div className=' d-flex gap-2 flex-column  align-items-center'>
                        <div>
                            <span className='icon-primary'>{item?.icon}</span>
                        </div>
                        <div>
                            <p>{item?.name}</p>
                        </div>
                    </div>
                </Link>
            ))}
        </div>
    </>
  )
}

export default SavingsPolicyReport